import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';

import routes from '~/routes';

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <NuqsAdapter>
      <RouterProvider router={router} />
    </NuqsAdapter>
  );
}
